// Basic
import PropTypes from 'prop-types';
// Components
import Icon from '@/common-utils/components/renders/icon/Icon';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.organizationSimOffers
 * @param root0.simOffersCategory
 * @returns {JSX} SimOffersSection
 */
function SimOffersSection({ organizationSimOffers, simOffersCategory }) {
    // Constants
    const simOffers = organizationSimOffers[simOffersCategory.name] ?? [];

    return (
        <div className='space-y-2' >
            <Entity
                entity={simOffersCategory.entities.manage}
                namespace={nsOrganization}
                className='text-lg font-medium'
            />
            {simOffers.length ?
                <div className='grid grid-cols-[repeat(1,max-content)] sm:grid-cols-[repeat(2,max-content)] lg:grid-cols-[repeat(3,max-content)] gap-6'>
                    {simOffers.map((simOffer) =>
                        <div key={simOffer.uuid} className='flex gap-2'>
                            <Icon
                                className={simOffer.isActive ? 'text-success' : 'text-labelGray-foreground'}
                                icon={simOffer.isActive ? ICONS.VALIDATE : ICONS.CLOSE}
                            />
                            {simOffer.displayName}
                        </div>
                    )}
                </div>
                : <div className='text-center'>
                    <Entity entity={'table.no_result'} />
                </div>
            }
        </div>
    );
}

SimOffersSection.propTypes = {
    organizationSimOffers: PropTypes.object,
    simOffersCategory: PropTypes.object
};

export default SimOffersSection;